import { I18n } from "@assets/strings";
import moment from "moment";
import React from "react";
import styled from "styled-components";
import subscriberIcon from "@assets/images/subscriberIcon.svg";
import { useCurrentProfile } from "@domain/currentProfile/hooks";
import { Wallet } from "@domain/wallet/wallet";
import { Primary } from "@ui/components/containers/primary";
interface TransactionsTableProps extends React.HTMLAttributes<HTMLDivElement> {
	transactions: Wallet[];
}

export const TransactionsTable: React.FC<TransactionsTableProps> = ({ transactions }) => {
	const currentProfile = useCurrentProfile();
	return (
		<ListItem>
			<StyledTable>
				<tr>
					<StyledTableHeader>{I18n.t("shareroom.dashboard.transactions.table.object.title")}</StyledTableHeader>
					<StyledTableHeader>{I18n.t("shareroom.dashboard.transactions.table.date.title")}</StyledTableHeader>
					<StyledTableHeader>{I18n.t("shareroom.dashboard.transactions.table.mode.title")}</StyledTableHeader>
					<StyledTableHeader>{I18n.t("shareroom.dashboard.transactions.table.amount.title")}</StyledTableHeader>
				</tr>
				{transactions.map((item) => (
					<tr key={item.id}>
						<td>
							<StyledOperation>
								<img src={subscriberIcon} />
								<StyledContainerOperation>
									<StyledOperationType>
										{item.type === "CASHOUT"
											? I18n.t("shareroom.dashboard.transactions.table.cashout.title")
											: I18n.t(`shareroom.dashboard.transactions.table.subscription_mode.${item.subscriptionMode}`)}
									</StyledOperationType>
									<StyledOperationAuthor>
										{item.issuerPrimaryName} {item.issuerSecondaryName}
									</StyledOperationAuthor>
								</StyledContainerOperation>
							</StyledOperation>
						</td>
						<td>
							<StyledOperationDate>{moment(item.date).format("LLL")}</StyledOperationDate>
						</td>
						<td>
							<ContainerWallet>
								<StyledWalletType>{item.mode}</StyledWalletType>
								<StyledPhoneNumber>{item.issuerNumber}</StyledPhoneNumber>
							</ContainerWallet>
						</td>
						<td>
							{item.type === "CASHOUT" ? (
								<StyledOperationAmountWithdrawn>
									- {item.amountIUC} {currentProfile?.currency}
								</StyledOperationAmountWithdrawn>
							) : (
								<StyledOperationAmountSubscription>
									+ {item.amountIUC} {currentProfile?.currency}
								</StyledOperationAmountSubscription>
							)}
						</td>
					</tr>
				))}
			</StyledTable>
		</ListItem>
	);
};

const ListItem = styled.div`
	display: flex;
	flex-direction: column;
`;
const StyledTable = styled.table`
	width: 100%;
	border-spacing: 30px;
	@media (max-width: 900px) {
		table-layout: fixed;
		td {
			display: block;
			margin: 20px auto 20px;
			padding-top: 0;
		}
	}
`;
const StyledTableHeader = styled.th`
	text-align: left;
	font-weight: 600;
	font-size: 16px;
	line-height: 26px;
	border-bottom: 1px solid #ddd;
`;
const StyledOperation = styled.div`
	display: flex;
	flex-direction: row;
`;
const StyledContainerOperation = styled.div`
	margin-left: 10px;
`;
const StyledOperationType = styled(Primary)`
	font-weight: 700;
	font-size: 14px;
	line-height: 26px;
`;
const StyledOperationAuthor = styled.div`
	font-weight: 400;
	font-size: 10px;
	line-height: 13px;
	color: #206af8;
`;
const StyledOperationDate = styled(Primary)`
	font-weight: 400;
	font-size: 14px;
	line-height: 26px;
`;

const StyledWalletType = styled(Primary)`
	font-weight: 700;
	font-size: 14px;
	line-height: 26px;
	/* identical to box height, or 186% */
`;

const StyledPhoneNumber = styled(Primary)`
	font-size: 10px;
	line-height: 13px;
	/* identical to box height, or 186% */

	color: #fbb513;
`;

const StyledOperationAmountWithdrawn = styled(Primary)`
	font-weight: 400;
	font-size: 14px;
	line-height: 26px;
	color: #e83636;
`;

const StyledOperationAmountSubscription = styled(Primary)`
	font-weight: 400;
	font-size: 14px;
	line-height: 26px;

	color: rgba(52, 200, 15, 0.8);
`;

const ContainerWallet = styled.div`
	flex-direction: column;
`;
